import { useCallback } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useCause } from "../contexts/CauseContext";
import { getFunctions, httpsCallable } from "firebase/functions";

export default function useCauseInput() {
  const { userId } = useAuth();
  const { causeTypesTranslations } = useCause() || {};
  const validateCause = useCallback(async (cause) => {
    console.log("function: validateCause " + cause);

    try {
      const functions = getFunctions(undefined, "europe-west1");
      const chatEvaluateCause = httpsCallable(functions, "chatEvaluateCause");

      const existingList =
        Array.isArray(causeTypesTranslations) && causeTypesTranslations.length
          ? causeTypesTranslations.map((c) => c.translation).join(", ")
          : "";

      const { data } = await chatEvaluateCause({
        input: cause,
        existingList,
      });

      let reply = (data?.reply || "").trim();
      const validResponse = reply.includes("This is a valid response.");

      console.log("reply " + reply);

      return validResponse;
    } catch (err) {
      console.log(err);
    }
  }, []);

  return {
    validateCause,
    userId,
  };
}
